import React from "react";
import styled from "@emotion/styled";

import ParkkiTheme from "themes/ParkkiTheme";
import ParkkiLogo from "images/parkki-logo.png";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: ${ParkkiTheme.colors.blue};
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 450px;
  width: 50%;
`;

const FormContainer = styled.div`
  width: 100%;
  margin-top: 32px;
`;

const Title = styled.div`
  font-size: 14px;
  text-align: center;
  color: white;
  opacity: 0.85;
  margin-top: 4px;
`;

const ParkkiLogoImage = styled.img`
  min-width: 200px;
  width: 60%;
  height: auto;
`;

type Props = {
  children?: React.ReactNode;
  label: string;
};

function FormLayout({ children, label }: Props): JSX.Element {
  return (
    <Container>
      <ContentContainer>
        <ParkkiLogoImage src={ParkkiLogo} alt="Parkki" />
        <Title>{label}</Title>

        <FormContainer>{children}</FormContainer>
      </ContentContainer>
    </Container>
  );
}

export default FormLayout;
